import api from '../../utils/api'

import IUGU from "../../services/iugu"
import moment from 'moment'

export const state = {
  currentStep: { key: 'number-accesses', name: 'Quantidade de Usuários e Tempo de Contrato', completed: false },
  steps: [],
  discount: 0,
  billingData: {
    hits: 'acessos_para_mim_minha_equipe',
    numberAccesses: 0,
    numeroUsuariosExistentes: 0,
    precoCompraUsuariosSubordinados: 0,
    precoCompraUsuariosSubordinadosSemDesconto: 0,
    contractTimeYears: 1,
    type: null,
    usageProfile: 'professional',
    companyName: '',
    cnpj: '',
    name: '',
    document: '',
    birthDate: '',
    stateRegister: '',
    cityRegister: '',
    email: '',
    phone: '',
    customPlanCode: '',
    utm_source: '',
    utm_medium: '',
    utm_campaign: '',
    utm_id: '',
    utm_term: '',
    utm_content: '',
    adhesionContractAccepted: false,
    adhesionContractUrl: "",
    adhesionContractDate: "",
    adhesionContractName: "",
    termsOfUseAccepted: false,
    termsOfUseUrl: "",
    termsOfUseDate: "",
    termsOfUseName: "",
    privacyPolicyAccepted: false,
    privacyPolicyUrl: "",
    privacyPolicyDate: "",
    privacyPolicyName: "",
    address: {
      street: '',
      number: '',
      complement: '',
      neighborhood: '',
      cep: '',
      city: '',
      state: ''
    },
    emailReferral: null,
  },
  payment: {
    method: '',
    data: {
      full_name: '',
      first_name: '',
      last_name: '',
      number: '',
      month: '',
      year: '',
      cvv: '',
      installments: 1
    }
  },
  alertDetails: {
    open: false,
    message: '',
    type: ''
  },
  plan: {},
  emailIndication: null,
  promotion: {
    code: '',
  },
}

export const mutations = {
  SET_STEP_COMPLETED(state, { index, value }) {
    state.steps[index].completed = value
  },
  SET_STEP_UNSHIFT(state, steps) {
    state.steps = steps
  },
  SET_CURRENT_STEP(state, index) {
    state.currentStep = state.steps[index]
  },
  SET_BILLING_DATA(state, data) {
    state.billingData = data
  },
  SET_PAYMENT(state, data) {
    state.payment = data
  },
  SET_ALERT_DETAILS(state, data) {
    state.alertDetails = data
  },
  SET_PLAN(state, data) {
    state.plan = data
  },
  SET_PROMOTION(state, data) {
    state.promotion = data
  },
  SET_DISCOUNT(state, discount) {
    state.discount = discount
  },
  SET_PRECOCOMPRAUSUARIOSSUBORDINADOS(state, precoCompraUsuariosSubordinados) {
    state.billingData.precoCompraUsuariosSubordinados = precoCompraUsuariosSubordinados
  },
  SET_PRECOCOMPRAUSUARIOSSUBORDINADOS_SEM_DESCONTO(state, precoCompraUsuariosSubordinadosSemDesconto) {
    state.billingData.precoCompraUsuariosSubordinadosSemDesconto = precoCompraUsuariosSubordinadosSemDesconto
  },
  SET_EMAIL_INDICATION(state, emailIndication) {
    state.emailIndication = emailIndication
  },
  SET_NUMBER_ACCESSES(state, numberAccesses) {
    state.billingData.numberAccesses = numberAccesses
  },
  SET_QUANTIDADE_ACESSO_EM_ANOS(state, contractTimeYears) {
    state.billingData.contractTimeYears = contractTimeYears
  },
  SET_HITS(state, hits) {
    state.billingData.hits = hits
  },
  SET_TYPE(state, type) {
    state.billingData.type = type
  },
  SET_METHOD(state, method) {
    state.payment.method = method
  },
  SET_EMAILREFERRAL(state, emailReferral) {
    state.billingData.emailReferral = emailReferral
  },
}

function getIndexStep(state, stepKey) {
  let index = 0

  state.steps.forEach((step, i) => {
    if (step.key === stepKey) {
      index = i
    }
  })
  return index
}
function precoCompraUsuariosSubordinados(precoNoCheckout, totalUsuariosSubordinadosAoUsuarioMaster) {
  const descontoBase = 0.09;
  const maximumDiscount = 0.19;
  let total = 0;
  let desconto = (0.01 * totalUsuariosSubordinadosAoUsuarioMaster) + descontoBase
  if (desconto > maximumDiscount) {
    desconto = maximumDiscount
  }
  for (let i = 1; i <= totalUsuariosSubordinadosAoUsuarioMaster ; i++) {
    const precoPorAcesso = Number(precoNoCheckout) * (1 - desconto)
    total += Number(precoPorAcesso)
  }
  return total
}

export const actions = {
  handleResetBillingData: ({ commit }) => commit('SET_BILLING_DATA', {
    type: 'person',
    companyName: '',
    cnpj: '',
    name: '',
    document: '',
    stateRegister: '',
    cityRegister: '',
    email: '',
    phone: '',
    address: {
      street: '',
      number: '',
      complement: '',
      neighborhood: '',
      cep: '',
      city: '',
      state: ''
    },
    emailReferral: null,
  }),
  handleSetBillingData: ({ commit }, data) => commit('SET_BILLING_DATA', data),
  handleResetPayment: ({ commit }) => commit('SET_PAYMENT', {
    method: '',
    data: {
      full_name: '',
      first_name: '',
      last_name: '',
      number: '',
      month: '',
      year: '',
      cvv: '',
      installments: 1
    }
  }),
  handleSetPayment: ({ commit }, data) => commit('SET_PAYMENT', data),
  handleSetEmailindication: ({ commit }, emailIndication) => commit('SET_EMAIL_INDICATION', emailIndication),
  handleSetdiscount: ({ commit }, discount) => commit('SET_DISCOUNT', discount),
  handleSetEmailReferral: ({ commit }, emailReferral) => commit('SET_EMAILREFERRAL', emailReferral),
  handleSetAlertDetails: ({ commit }, data) => commit('SET_ALERT_DETAILS', data),
  handleResetAlertDetails: ({ commit }) => commit('SET_ALERT_DETAILS', {
    open: false,
    message: '',
    type: '',
  }),
  handleSetPlan: ({ commit }, data) => commit('SET_PLAN', data),
  handleSetPromotion: ({ commit }, data) => {commit('SET_PROMOTION', data)},
  handleResetPromotion: ({ commit }) => commit('SET_PROMOTION', {
    code: '',
  }),
  handleResetSteps: ({ commit }) => commit('SET_CURRENT_STEP', 0),
  handleNextStep({ state, commit }) {
    const currentStep = state.currentStep
    let index = getIndexStep(state, currentStep.key)

    commit('SET_STEP_COMPLETED', { index, value: true })
    commit('SET_CURRENT_STEP', index + 1)
  },
  handleBackStep({ state, commit }) {
    const currentStep = state.currentStep
    let index = getIndexStep(state, currentStep.key)

    if (currentStep.key === 'confirmation') {
      commit('SET_PAYMENT', {
        method: '',
        data: {
          full_name: '',
          first_name: '',
          last_name: '',
          number: '',
          month: '',
          year: '',
          cvv: '',
          installments: 1
        }
      })
    }

    commit('SET_STEP_COMPLETED', { index, value: false })
    commit('SET_CURRENT_STEP', index - 1)
  },
  async handleGetTokenCreditCard({ state }) {
    const profile = state.billingData
    const payment = state.payment

    let response = await IUGU.getTokenCreditCard({ profile, payment })

    return response
  },
  async handleSubmitCheckout({ state }) {
    const profile = state.billingData
    const payment = state.payment
    const plan = state.plan
    const promotion = state.promotion
    const emailIndication = state.emailIndication
    const adhesionContractAccepted = profile.adhesionContractAccepted
    const adhesionContractUrl = profile.adhesionContractUrl
    const adhesionContractDate = profile.adhesionContractDate
    const adhesionContractName = profile.adhesionContractName
    const termsOfUseAccepted = profile.termsOfUseAccepted
    const termsOfUseUrl = profile.termsOfUseUrl
    const termsOfUseDate = profile.termsOfUseDate
    const termsOfUseName = profile.termsOfUseName
    const privacyPolicyAccepted = profile.privacyPolicyAccepted
    const privacyPolicyUrl = profile.privacyPolicyUrl
    const privacyPolicyDate = profile.privacyPolicyDate
    const privacyPolicyName = profile.privacyPolicyName
    const contractTimeYears = profile.contractTimeYears

    profile.document = profile.document.replace(/\D+/g, '')
    profile.address.cep = profile.address.cep.replace(/\D+/g, '')

    delete payment.data

    const body = {
      profile: {
        name: profile.name || '',
        email: profile.email || '',
        phone: profile.phone.replace(/\D+/g, '') || '',
        cpf: profile.document || '',
        cnpj: profile.cnpj || '',
        companyName: profile.companyName || '',
        type: profile.type || '',
        usageProfile: profile.usageProfile || 'professional',
        address: profile.address.street || '',
        complement: profile.complement || '',
        number: profile.address.number || '',
        cep: profile.address.cep || '',
        neighborhood: profile.address.neighborhood || '',
        city: profile.address.city || '',
        state: profile.address.state || '',
        stateRegister: profile.stateRegister || '',
        cityRegister: profile.cityRegister || '',
      },
      customPlanCode: profile.customPlanCode ? profile.customPlanCode : '',
      numberAccesses: profile.numberAccesses ? Number(profile.numberAccesses) : 0,
      utm_source: profile.utm_source ? profile.utm_source : null,
      utm_medium: profile.utm_medium ? profile.utm_medium : null,
      utm_campaign: profile.utm_campaign ? profile.utm_campaign : null,
      utm_id: profile.utm_id ? profile.utm_id : null,
      utm_term: profile.utm_term ? profile.utm_term : null,
      utm_content: profile.utm_content ? profile.utm_content : null,
      payment: {
        method: payment.method || ''
      },
      plan: plan.code || '',
      code: promotion.code || '',
      emailIndication: emailIndication || null,
      adhesionContractAccepted,
      adhesionContractUrl,
      adhesionContractDate,
      adhesionContractName,
      termsOfUseAccepted,
      termsOfUseUrl,
      termsOfUseDate,
      termsOfUseName,
      privacyPolicyAccepted,
      privacyPolicyUrl,
      privacyPolicyDate,
      privacyPolicyName,
      contractTimeYears,
      urlCheckout: window.location.href,
      emailReferral: profile.emailReferral ? profile.emailReferral : null,
    }


    if (payment.method === 'credit_card') {
      body.payment.creditCard = payment.token
      body.month = payment.installments
    }

    const { data } = await api.post('/checkout', body)

    return data
  },
  async handleGetAmountPaidPlan(_, planId) {
    const { data } = await api.get(`/checkout/amountPaidPlan/${planId}`)

    return data
  },
  handleSetStepUnshift: ({ commit }, data) => commit('SET_STEP_UNSHIFT', data),
  async handleSeNumberAccesses({ commit, numberAccesses }){
    commit('SET_NUMBER_ACCESSES', numberAccesses)
  },
  async calculateTotalPlan({ state, commit }) {
    const desconto = state.discount ? state.discount : 0
    const numberAccesses = parseFloat(state.billingData.numberAccesses)
    const valorCompraUsuariosSubordinados = precoCompraUsuariosSubordinados(((parseFloat(state.plan.value) - desconto) * parseInt(state.billingData.contractTimeYears)), numberAccesses);
    const valorCompraUsuariosSubordinadosSemsedeconto = precoCompraUsuariosSubordinados((parseFloat(state.plan.value) * parseInt(state.billingData.contractTimeYears)), numberAccesses);
    /*console.log('valorCompraUsuariosSubordinadosSemsedeconto')
    console.log(valorCompraUsuariosSubordinadosSemsedeconto)
    console.log('valorCompraUsuariosSubordinadosSemsedeconto')*/
    commit('SET_PRECOCOMPRAUSUARIOSSUBORDINADOS', valorCompraUsuariosSubordinados ? valorCompraUsuariosSubordinados : 0)
    commit('SET_PRECOCOMPRAUSUARIOSSUBORDINADOS_SEM_DESCONTO', valorCompraUsuariosSubordinadosSemsedeconto ? valorCompraUsuariosSubordinadosSemsedeconto : 0)
    return valorCompraUsuariosSubordinados
  },
  async handleChangeSubscriptionPaymentMethod(_, subscription) {
    return await api.put('/checkout/subscriptionsPaymentMethod', subscription)
  },
  handleSetQuantidadeAcessoEmAnos({ commit }, contractTimeYears) {
    commit('SET_QUANTIDADE_ACESSO_EM_ANOS', contractTimeYears)
  },
  handleSetHits({ commit }, hits) {
    commit('SET_HITS', hits)
  },
  handleSetType({ commit }, type) {
    commit('SET_TYPE', type)
  },
  handleSetMethod({ commit }, method) {
    commit('SET_METHOD', method)
  },
}

export const getters = {
  getSteps: (state) => state.steps,
  getCurrentStep: (state) => state.currentStep,
  getBillingData: (state) => state.billingData,
  getPayment: (state) => state.payment,
  getIsCreditCard: (state) => state.payment.method === 'credit_card',
  getAlertDetails: (state) => state.alertDetails,
  getPlan: (state) => state.plan,
  getPromotion: (state) => state.promotion,
  getDiscount: (state) => state.discount,
  getEmailIndication: (state) => state.emailIndication,
}
